import React, { useEffect, useState } from 'react'
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { LoginScreen } from '../Component/login/LoginScreen';
import { recuperarLoginActionAxios } from '../actions/auth'
import { BrowserRouter } from "react-router-dom";
import { PrivateRoute } from './PrivateRoute';
import { DashboardRoutes } from './DashboardRoutes';
import { PublicRoute } from './PublicRoute';
import SpinerLoader from '../Helpers/SpinerLoader';



export const AppRouter = () => {
    const dispatch = useDispatch();
    const [verificant, setVerificant] = useState(true);
    const { auth, ui } = useSelector(state => state);

    useEffect(() => {
        dispatch(recuperarLoginActionAxios());
    }, []);

    useEffect(() => {
        if (!ui.loading && verificant) {
            setVerificant(false);
        }
    }, [ui.loading]);

    if (verificant) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <SpinerLoader />
            </div>
        );
    }

    const loginat = !!auth.tokenJwt;

    return (
        <div className="">
            <BrowserRouter>
                <Routes>
                    <Route path="/login/*" element={
                        <PublicRoute>
                            <LoginScreen estaLoginat={loginat} />
                        </PublicRoute>
                    } />
                    <Route path="/*" element={
                        <PrivateRoute estaLoginat={loginat}>
                            <DashboardRoutes />
                        </PrivateRoute>
                    } />
                </Routes>
            </BrowserRouter>
        </div>
    );
}